import EmblaCarousel from 'embla-carousel';
import ClassNames from "embla-carousel-class-names";
/**
 * Cards carousel
 * @class
 */
export default class Carousel {
    constructor(element) {
        this.loadEmbla(element);
    }
    /**
     * Load embla
     */
    loadEmbla(parentEl) {
        if (!parentEl)
            return;
        const container = parentEl.querySelector('.embla__viewport');
        if (container !== null) {
            const nextBtn = parentEl.querySelector('.embla__next');
            const prevBtn = parentEl.querySelector('.embla__prev');
            const options = {
                active: false,
                loop: false,
                slidesToScroll: 1,
                trimSnaps: true,
                breakpoints: {
                    '(min-width: 768px)': { active: true },
                },
            };
            const embla = EmblaCarousel(container, options, [ClassNames()]);
            //next/prev btns
            const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
                const scrollPrev = () => {
                    embla.scrollPrev();
                    container.classList.add('prev');
                    container.classList.remove('next');
                };
                const scrollNext = () => {
                    embla.scrollNext();
                    container.classList.add('next');
                    container.classList.remove('prev');
                };
                prevBtn.addEventListener('click', scrollPrev, false);
                nextBtn.addEventListener('click', scrollNext, false);
            };
            const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
                return () => {
                    if (embla.canScrollPrev())
                        prevBtn.removeAttribute('disabled');
                    else
                        prevBtn.setAttribute('disabled', 'disabled');
                    if (embla.canScrollNext())
                        nextBtn.removeAttribute('disabled');
                    else
                        nextBtn.setAttribute('disabled', 'disabled');
                };
            };
            const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);
            if (prevBtn && nextBtn) {
                setupPrevNextBtns(prevBtn, nextBtn, embla);
                embla.on('init', disablePrevAndNextBtns);
                embla.on('select', disablePrevAndNextBtns);
            }
            const cards = parentEl.querySelectorAll('[data-component="Card"]');
            cards.forEach((item, index) => {
                if (index === 0)
                    item.classList.add('cards__item--top');
                if (index === 1)
                    item.classList.add('cards__item--middle');
                if (index === 2)
                    item.classList.add('cards__item--bottom');
                if (index > 2)
                    item.classList.add('cards__item--bottom');
            });
            embla.on('scroll', () => {
                const inView = embla.slidesInView();
                const x = [...embla.slideNodes()].filter((item, index) => inView.includes(index));
                x.forEach((item, index) => {
                    item.classList.remove('cards__item--top');
                    item.classList.remove('cards__item--middle');
                    item.classList.remove('cards__item--bottom');
                    if (index === 0 || index === 1)
                        item.classList.add('cards__item--top');
                    if (index === 2)
                        item.classList.add('cards__item--middle');
                    if (index === 3 || index === 4)
                        item.classList.add('cards__item--bottom');
                    if (prevBtn.getAttribute('disabled')) {
                        if (index === 1)
                            item.classList.remove('cards__item--top');
                        if (index === 2)
                            item.classList.remove('cards__item--middle');
                        if (index === 2)
                            item.classList.add('cards__item--bottom');
                    }
                });
            });
        }
    }
    static init(scope) {
        [
            ...(scope || document).querySelectorAll('[data-component="emblaCarousel"]'),
        ].forEach((elem) => {
            new Carousel(elem);
        });
    }
}
